<x-chartist [type]="'Pie'" [data]="labelsPieData" [options]="labelsPieOptions"
  [responsiveOptions]="labelsPieResponsiveOptions" class="height-300">
</x-chartist>